// Espelho de reference/expo-frontend/lib/permissions.ts e de
// api-server/src/lib/permissions.ts — Única fonte de regras de papel no web.
// O servidor continua sendo a autoridade (controles escondidos aqui apenas
// evitam 403 visíveis).
import type { Role } from "@/types";

/** Valores em dinheiro nos Rankings/Histórico são mascarados para não-admins. */
export function canSeeMoneyValues(role: Role): boolean {
  return role === "super_admin" || role === "admin";
}

export function canManageUsers(role: Role): boolean {
  return role === "super_admin" || role === "admin";
}

export function canAdjustBalance(role: Role): boolean {
  return role === "super_admin";
}

export function canAssignRole(actingRole: Role, targetRole: Role): boolean {
  if (!canManageUsers(actingRole)) return false;
  if (targetRole === "super_admin") return actingRole === "super_admin";
  return true;
}
